import DialogComponent from "components/Dialog";

export default class ChangeNoteDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general",
            currentCanal: false
        };
    }

    title = "client.note";

    show(info, hideCb, dialogFor) {
        this.info = info;
        this.hidCb = hideCb;

        this.dialogTitle = dialogFor === "general" ? "client.note" : "client.editComment";
        this.state.dialogFor = dialogFor;

        super.show();
    }

    onShow() {
        if (this.info?.comment) {
            this.commentInput.value = this.info?.comment;
            this.setState({ currentCanal: this.info?.currentCanal });
        }

    }

    save() {
        const { dialogFor, currentCanal: source } = this.state;
        if (this.hidCb?.apply) {
            if (dialogFor === "general")
                this.hidCb({ comment: this.commentInput.value, source, id: this.info.id });
            else
                this.hidCb({ comment: this.commentInput.value }, this.info.id);
        }

        this.hide();
    }

    renderContent() {
        const { dialogFor, currentCanal } = this.state;
        const { sourceComment } = this._config;
        const label = dialogFor === "general" ? "client.note" : "client.comment";
        return (
            <div className="content flex col gap16">
                {dialogFor === "general" && this.insertSelect({
                    label: "Канал",
                    translate: true,
                    placeHolder: "Выберите канал",
                    showLeftIcon: false,
                    value: currentCanal,
                    items: sourceComment,
                    onChange: this.changeState.bind(this, "currentCanal")
                })}
                {this.insertInput({
                    ref: el => this.commentInput = el,
                    label: label,
                    placeHolder: label
                })}
            </div>
        );
    }
}

